import api from "src/shared/api";
import {
  IErpPartnerClientsAccumulationQuery,
  IPartnerClientsData,
  IErpPartnerClientsShowBonusesResponse,
} from "../model/types/types";

const erpPartnerClientsAccumulationApi = api.injectEndpoints({
  endpoints: (build) => ({
    getErpPartnerClientsAccumulation: build.query<
      IPartnerClientsData,
      IErpPartnerClientsAccumulationQuery
    >({
      query: (params) => {
        return {
          url: `api/partners/${params.partner_id}/clients`,
          method: "GET",
          params,
        };
      },
    }),
    exportErpPartnerClientsAccumulation: build.query<
      string,
      IErpPartnerClientsAccumulationQuery
    >({
      query: (params) => {
        return {
          url: `api/partners/${params.partner_id}/clients/export`,
          method: "GET",
          params,
          responseHandler: (response) => response.text(),
        };
      },
      transformResponse: (response: string) => response,
    }),
    getErpPartnerClientsShowBonuses: build.query<
      IErpPartnerClientsShowBonusesResponse,
      IErpPartnerClientsAccumulationQuery
    >({
      query: (params) => {
        return {
          url: `api/partners/${params.partner_id}/virtual-contracts/${params.virtual_contract_id}/bonus-percents-ranges`,
          method: "GET",
          params,
        };
      },
    }),
  }),
});

export const {
  useGetErpPartnerClientsAccumulationQuery,
  useLazyExportErpPartnerClientsAccumulationQuery,
  useLazyGetErpPartnerClientsShowBonusesQuery,
} = erpPartnerClientsAccumulationApi;
